import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Bir hata oluştu. Lütfen tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const errMsg = (e) => formatApiErrorDetail(e?.response?.data?.detail);

/** Archive/cancel with confirmation; repeats with ?confirm=true when backend reports linked payments (409). */
export async function confirmDelete(url, question = "Bu kaydı silmek istediğinize emin misiniz?") {
  if (!window.confirm(question)) return false;
  try {
    await api.delete(url);
  } catch (e) {
    if (e.response?.status !== 409 || !window.confirm(`${errMsg(e)}\n\nDevam edilsin mi?`)) throw e;
    await api.delete(url, { params: { confirm: true } });
  }
  return true;
}

export const money = (n) =>
  n === null || n === undefined
    ? "-"
    : new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(n);

export const compact = (n) => new Intl.NumberFormat("tr-TR", { notation: "compact", maximumFractionDigits: 1 }).format(n || 0);

export const formatDate = (d) => {
  if (!d) return "-";
  const dt = new Date(d.length === 10 ? `${d}T00:00:00` : d);
  return isNaN(dt) ? "-" : dt.toLocaleDateString("tr-TR", { day: "2-digit", month: "short", year: "numeric" });
};

export const formatDateTime = (d) => {
  if (!d) return "-";
  const dt = new Date(d);
  return isNaN(dt) ? "-" : dt.toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

export const todayStr = () => new Date().toISOString().slice(0, 10);

export function downloadCsv(filename, rows) {
  const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  const csv = "\uFEFF" + rows.map((r) => r.map(esc).join(";")).join("\n");
  const link = document.createElement("a");
  link.href = URL.createObjectURL(new Blob([csv], { type: "text/csv;charset=utf-8" }));
  link.download = filename;
  link.click();
}
